import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _filter from 'lodash/filter';
import Article from '../components/Article';
import RelatedArticles from '../components/RelatedArticles';
import * as shape from '../constants/PropTypesShapes';


class ActiveArticle extends Component {
  static renderWithAnimation(component) {
    return (
      <ReactCSSTransitionGroup
        transitionName="expand"
        transitionEnterTimeout={250}
        transitionLeave={false}
      >
        {component}
      </ReactCSSTransitionGroup>
    );
  }
  isLoading() {
    return this.props.isLoadingArticle;
  }
  emptyChecker() {
    return this.props.relatedArticles.length === 0 && (!this.props.article);
  }
  reletedArticleFilter() {
    const articleTitle = this.props.article && this.props.article.articleTitle;
    return _filter(this.props.relatedArticles, relatedArticle => (
      articleTitle !== relatedArticle.articleTitle
    ));
  }
  renderArticle() {
    const article = this.props.article;
    if (!article) {
      return null;
    }
    return (
      <div className="article-content">
        <Article article={article} />
      </div>
    );
  }
  renderRelatedArticle() {
    const relatedArticles = this.reletedArticleFilter();
    let displayNumber = 2;
    let upfrontFAQId = '';
    if (relatedArticles.length === 0) {
      return null;
    }
    if (!this.props.article || this.props.article === {}) {
      displayNumber = 5;
    } else {
      upfrontFAQId = `|${this.props.article.articleId}`;
    }
    return (
      <div className="related-article-content">
        <RelatedArticles
          header={this.props.content.upfrontFaq.relatedArticle}
          relatedArticles={relatedArticles}
          displayNumber={displayNumber}
          upfront={upfrontFAQId}
        />
      </div>
    );
  }

  renderEnter() {
    if (this.isLoading()) {
      return null;
    }
    return (
      <div className="active-article-content">
        {this.renderArticle()}
        {this.renderRelatedArticle()}
      </div>
    );
  }

  renderHeaderAndContent() {
    if (!this.props.display || this.emptyChecker()) {
      return null;
    }
    return (
      <div className="article-container">
        <div className="col-xs-0 col-sm-1 col-md-1 col-lg-1" />
        <div className="col-xs-12 col-sm-10 col-md-10 col-lg-10">
          <div className="vx_alert vx_alert-help">
            <div className="vx_alert-text">
              <p className="upfront-header">{this.props.content.upfrontFaq.header}</p>
              {ActiveArticle.renderWithAnimation(this.renderEnter())}
            </div>
          </div>
        </div>
        <div className="col-xs-0 col-sm-1 col-md-1 col-lg-1" />
      </div>
    );
  }

  render() {
    return this.renderHeaderAndContent();
  }
}

ActiveArticle.propTypes = {
  isLoadingArticle: PropTypes.bool,
  article: PropTypes.shape(shape.FAQ_ARTICLE),
  relatedArticles: PropTypes.arrayOf(PropTypes.shape(shape.FAQ_RELATED_ARTICLE)),
  display: PropTypes.bool,
  content: PropTypes.shape(shape.FAQ_ACTIVE_ARTICLE_CONTENT),
};

ActiveArticle.defaultProps = {
  isLoadingArticle: true,
  article: undefined,
  relatedArticles: [],
  display: false,
  content: {
    'upfrontFaq.header': 'This information might help',
    'upfrontFaq.relatedArticle': 'Related topics',
  },
};

function mapStateToProps({ activeArticle }) {
  return {
    article: activeArticle.article,
    relatedArticles: activeArticle.relatedArticles,
    isLoadingArticle: activeArticle.isLoadingArticle,
    display: activeArticle.display,
    content: window.localeBundle ? window.localeBundle['smarthelp/channelSelection'] : {},
  };
}


export default connect(mapStateToProps)(ActiveArticle);
